import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/bulkOrder/page',
    method: 'get',
    params
  })
}
export function pageByContractId(params) {
  return request({
    url: '/api/business/bulkOrder/pageByContractId',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/business/bulkOrder',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/bulkOrder',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/bulkOrder/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/bulkOrder',
    method: 'get',
    params: {
      id
    }
  })
}

export function finish(id) {
  return request({
    url: '/api/business/bulkOrder/finish',
    method: 'post',
    params: {
      id
    }
  })
}
export function getContractBulkOrderCollInfo(id) {
  return request({
    url: '/api/business/bulkOrder/getContractBulkOrderCollInfo',
    method: 'get',
    params: {
      id
    }
  })
}
export function updateStatus(id, status) {
  return request({
    url: '/api/business/bulkOrder/updateStatus',
    method: 'get',
    params: {
      id,
      status
    }
  })
}
export function copyBulkOrder(id) {
  return request({
    url: '/api/business/bulkOrder/copyBulkOrder',
    method: 'get',
    params: {
      id
    }
  })
}

export function noTagPage(params) {
  return request({
    url: '/api/business/bulkOrder/noTagPage',
    method: 'get',
    params
  })
}

export function revocationImportInventory(id) {
  return request({
    url: '/api/business/bulkOrder/revocationImportInventory',
    method: 'get',
    params: {
      id
    }
  })
}


